import {React} from 'react'
import styled from 'styled-components'
import { DarkTheme } from '../components/Themes'
import {Link} from 'react-router-dom'



const Logo = styled(Link)`
display: inline-block;
text-decoration:none;
font-size:40px;
color: ${props => props.color === 'dark' ? DarkTheme.text : DarkTheme.body};
font-family: 'Pacifico',cursive;
position: fixed;
left: 2rem;
top: 2rem;
z-index:3;
`

const LogoComponent = (props) => {

    return (
        <Logo to="/" color={props.theme}>
            MS
        </Logo>
    )
}

export default LogoComponent
